import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";
import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";
import VueFeather from 'vue-feather';
import { permissionsDirective } from '@/directives/permissionDirective';
import '@/assets/scss/config/default/app.scss';
import "leaflet/dist/leaflet.css";
import '@/assets/scss/mermaid.min.css';
import '@/assets/scss/custom.scss';
import 'bootstrap/dist/js/bootstrap.bundle';
import { installUsageAnalytics } from '@/analytics/usageAnalytics';

AOS.init({
  easing: 'ease-out-back',
  duration: 1000
});

installUsageAnalytics(router);

const app = createApp(App);

// Global Session helper
app.config.globalProperties.$hasPermission = function (required) {
  const currentUserPrivileges =
      JSON.parse(sessionStorage.getItem("privileges")) || [];

  const requiredPrivileges = Array.isArray(required)
      ? required
      : [required];

  return requiredPrivileges.some((priv) =>
      currentUserPrivileges.includes(priv)
  );
};

app.directive("has-permission", {
  mounted(el, binding) {
    const currentUserPrivileges =
        JSON.parse(sessionStorage.getItem("privileges")) || [];

    // 1. Normalize the input into a clean array of strings
    let requiredPrivileges = [];

    if (Array.isArray(binding.value)) {
      requiredPrivileges = binding.value;
    } else if (typeof binding.value === 'string') {
      // Split by comma and trim whitespace from each entry
      requiredPrivileges = binding.value.split(',').map(p => p.trim());
    }

    // 2. Check if the user has AT LEAST ONE of the required privileges
    const hasPerm = currentUserPrivileges.some(userPriv =>
        requiredPrivileges.includes(userPriv.value)
    );

    // 3. If no permission, remove the element from the DOM
    if (!hasPerm) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        // Fallback for cases where parent isn't immediately available
        el.style.display = 'none';
      }
    }
  },
});

app
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .use(i18n)
    .use(vClickOutside);

// Register the permissions directive
app.directive('permissions', permissionsDirective);

app.mount('#app');
